var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('create-dialog',{ref:"CreateDialogRef",on:{"editSubmit":_vm.onSubmit},model:{value:(_vm.createShow),callback:function ($$v) {_vm.createShow=$$v},expression:"createShow"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }